// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__1Pehr","fileBtn":"File_fileBtn__1z2xC","closeBtn":"File_closeBtn__2ZEHI","fileSelected":"File_fileSelected__27Bto","disabled":"File_disabled__nL1sg"};